/* eslint-disable react/react-in-jsx-scope */
import { FILTER_CHAINAGE, USER_ALLOCATION, USER_ALLOCATION_ERROR, USER_ALLOCATION_SUCCESS, 
	ROU_USER_DETAILS, ROU_USER_DETAILS_ERROR, ROU_USER_DETAILS_SUCCESS, CRO_USER_DETAILS, 
	CRO_USER_DETAILS_ERROR, CRO_USER_DETAILS_SUCCESS, USER_LIST, USER_LIST_ERROR, USER_LIST_SUCCESS, 
	SUPERVISOR_USER_DETAILS, SUPERVISOR_USER_DETAILS_SUCCESS, SUPERVISOR_USER_DETAILS_ERROR, LINEWALKER_USER_DETAILS, 
	LINEWALKER_USER_DETAILS_SUCCESS, LINEWALKER_USER_DETAILS_ERROR, NPV_USER_DETAILS, NPV_USER_DETAILS_SUCCESS, 
	NPV_USER_DETAILS_ERROR, EDIT_USER_ALLOCATION, EDIT_USER_ALLOCATION_SUCCESS, EDIT_USER_ALLOCATION_ERROR, ADD_ALLOCATION, 
	ADD_ALLOCATION_SUCCESS, ADD_ALLOCATION_ERROR, EDIT_ALLOCATION, EDIT_ALLOCATION_SUCCESS, EDIT_ALLOCATION_ERROR, 
	ALLOCATION_USER_DETAILS_SUCCESS, ALLOCATION_USER_DETAILS_ERROR, ALLOCATION_USER_DETAILS, ALLOCATION_SUB, 
	ALLOCATION_SUB_SUCCESS, ALLOCATION_SUB_ERROR, ALLOCATION_PIPELINE_PATH, ALLOCATION_PIPELINE_PATH_SUCCESS, ALLOCATION_PIPELINE_PATH_ERROR, EDIT_ALLOCATION_PIPELINE_PATH, EDIT_ALLOCATION_PIPELINE_PATH_SUCCESS, EDIT_ALLOCATION_PIPELINE_PATH_ERROR, INSPECTION_LIST, INSPECTION_LIST_SUCCESS, INSPECTION_LIST_ERROR, USERS_LIST, USERS_LIST_SUCCESS, USERS_LIST_ERROR,LOG_LIST,LOG_LIST_SUCCESS,LOG_LIST_ERROR,GEOFENCE_MANAGEMENT_LIST ,GEOFENCE_MANAGEMENT_LIST_SUCCESS ,GEOFENCE_MANAGEMENT_LIST_ERROR, 
	SCHEDULE_LIST,
	SCHEDULE_LIST_SUCCESS,
	SCHEDULE_LIST_ERROR,
	DELETE_SCHEDULE,
	DELETE_SCHEDULE_SUCCESS,
	DELETE_SCHEDULE_ERROR,
	SCHEDULE_DETAILS,
	SCHEDULE_DETAILS_SUCCESS,
	SCHEDULE_DETAILS_ERROR,
	SCHEDULE_UPDATE_SUCCESS,
	SCHEDULE_UPDATE,
	SCHEDULE_UPDATE_ERROR,
	ADD_SCHEDULE,
	ADD_SCHEDULE_SUCCESS,
	ADD_SCHEDULE_ERROR,
	QRT_USER_DETAILS,
	QRT_USER_DETAILS_SUCCESS,
	QRT_USER_DETAILS_ERROR,
	OPTIONAL_PATH_LIST,
	OPTIONAL_PATH_LIST_SUCCESS,
	OPTIONAL_PATH_LIST_ERROR,
	DELETE_OPTIONAL_PATH,
	DELETE_OPTIONAL_PATH_SUCCESS,
	DELETE_OPTIONAL_PATH_ERROR,
	OPTIONAL_PATH_LIST_DETAILS,
	OPTIONAL_PATH_LIST_DETAILS_SUCCESS,
	OPTIONAL_PATH_LIST_DETAILS_ERROR} from './constants';
	
import { datetimeCovertertolocal } from '../datetime-converter';


import { TASK_LIST, TASK_LIST_SUCCESS, TASK_LIST_ERROR } from './constants';
import { TASK_LIST_DETAILS, TASK_LIST_DETAILS_SUCCESS, TASK_LIST_DETAILS_ERROR } from './constants';
import { ADD_TASK_LIST_DETAILS, ADD_TASK_LIST_DETAILS_SUCCESS, ADD_TASK_LIST_DETAILS_ERROR } from './constants';
import { UPDATE_TASK_LIST, UPDATE_TASK_LIST_DETAILS_SUCCESS, UPDATE_TASK_LIST_DETAILS_ERROR } from './constants';
import { DELETE_TASK_LIST, DELETE_TASK_LIST_SUCCESS, DELETE_TASK_LIST_ERROR } from './constants';


export default function AllocationReducer(state, action) {
	let pagination = {};
	let users = [];
	let rou = [];
	let cro = [];
	let allocation = [];
	let filterChainage = [];
	let supervisor = [];
	let linewalker = [];
	let npv = [];
	let edit_allocation = [];
	let allocateSubUser = [];
	let linewalkerAllocation = [];
	let logs = [];
	let tasks = [];
	let geofencemanagement = [];
	let schedule = [];
	let qrt = [];
	let path = [];

	

	switch(action.type) {
	case USER_LIST :
		return { ...state, pending: true };
	case USER_LIST_SUCCESS :
		if (action.payload) {
			pagination.total = action.payload.total ? action.payload.total : 0;
			pagination.limit = action.payload.limit ? action.payload.limit : 10;
			pagination.skip = action.payload.skip ? action.payload.skip : 0;
			pagination.current = action.page ? action.page : 1;
			pagination.pageSize =  action.pageSize ? action.pageSize : 10;
		}
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map((item) => {
				
				if(item.usertypeId != 8) {
					users.push({
						id : item.id,
						name : `${item.firstName} ${item.lastName}`,
						email : item.email,
						cellPhone : item.cellPhone,
						usertype : item.usertype.userType,
						usertypeId : item.usertypeId,
						pipelineId : item.pipelineId,
						allocationsList : item.allocationsList ? Array.isArray(item.allocationsList) === true ?
							item.allocationsList.map((data) => { return( <>{data.regioninfo.regionName} ( {data.pipelineConfigFrom} to {data.pipelineConfigTo} )<br/></> ); }) 
							: `${item.allocationsList.regioninfo.regionName} ( ${item.allocationsList.pipelineConfigFrom} to ${item.allocationsList.pipelineConfigTo} )` 
							: 'No allocation',
						geofenceName : item.allocationsList ? Array.isArray(item.allocationsList) === true ?
							item.allocationsList.map((data) => { return( <>{data?.geofencemanagement?.name}<br/></> ); }) 
							: `${item.allocationsList?.geofencemanagement ? item.allocationsList?.geofencemanagement.name : 'N/A'}` 
							: 'N/A',
						allocations : item.allocationsList ,
						currentPath : item && item?.userallocations.length > 0 ?  item?.userallocations.map(data => data.currentPath).join(', ') : 'N/A'
						
					});
				}
			});
		}
		return { ...state, pending : false, error : false, users : users, pagination: pagination };
	case USER_LIST_ERROR :
		return { ...state, error: false, pending: false };
	case ROU_USER_DETAILS :
		return { ...state, pending: true };
	case ROU_USER_DETAILS_SUCCESS :
		
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map((item) => {
				rou.push({
					label : `${item.firstName} ${item.lastName}`,
					value : item.id
				});
			});
		} else {
			rou = [];
		}
		return { ...state, pending : false, error : false, rou: rou, rouUserDetails : action.payload.data ? action.payload.data : [] };
	case ROU_USER_DETAILS_ERROR :
		return { ...state, error: true, pending: false };
	case CRO_USER_DETAILS :
		return { ...state, pending: true };
	case CRO_USER_DETAILS_SUCCESS : 
		
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map((item) => {
				cro.push({
					label : `${item.firstName} ${item.lastName}`,
					value : item.id
				});
			});
		} else {
			cro = [];
		}
		return { ...state, pending : false, error : false, cro :  cro, croUserDetails : action.payload.data ? action.payload.data : []};
	case CRO_USER_DETAILS_ERROR : 
		return { ...state, error: true, pending: false };
	case USER_ALLOCATION :
		return { ...state, pending: true };
	case USER_ALLOCATION_SUCCESS : 
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map((item) => {
				allocation.push({
					label : `${item.pipelineConfigFrom} ( ${item.rouMarkerFrom} ) - ${item.pipelineConfigTo} ( ${item.rouMarkerTo})`,
					value : `${item.id} ${item.pipelineConfigFrom} ${item.pipelineConfigTo}`
				});
			});
		} else {
			allocation = [];
		}
		return { ...state, pending : false, error : false, allocation :  allocation};
	case USER_ALLOCATION_ERROR :
		return { ...state, error: true, pending: false };
	case FILTER_CHAINAGE :
		action.chainage && action.chainage.map((item) => {
			if (item.pipelineChainage >= parseInt(action.value[1]) && item.pipelineChainage <= parseInt(action.value[2])) {
				filterChainage.push({
					value : item.id,
					label : `${item.pipelineChainage} ( ${item.rouMarker} )`
				});
			}
		});
		return { ...state, pending : false, error : false, filterChainage :  filterChainage};
	case SUPERVISOR_USER_DETAILS :
		return { ...state, pending: true };
	case SUPERVISOR_USER_DETAILS_SUCCESS :
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map((item) => {
				supervisor.push({
					label : `${item.firstName} ${item.lastName}`,
					value : item.id
				});
			});
		} else {
			supervisor = [];
		}
		return { ...state, pending : false, error : false , supervisor : supervisor, supervisorUserDetails : action.payload.data ? action.payload.data : []};
	case SUPERVISOR_USER_DETAILS_ERROR :
		return { ...state, error: true, pending: false };
	case LINEWALKER_USER_DETAILS : 
		return { ...state, pending: true };
	case LINEWALKER_USER_DETAILS_SUCCESS :
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map((item) => {
				linewalker.push({
					label : `${item.firstName} ${item.lastName}`,
					value : item.id
				});
			});
		} else {
			linewalker = [];
		}
		return { ...state, pending : false, error : false , linewalker : linewalker, linewalkerUserDetails : action.payload.data ? action.payload.data : []};
	case LINEWALKER_USER_DETAILS_ERROR :
		return { ...state, error: true, pending: false };
	case NPV_USER_DETAILS :
		return { ...state, pending: true };
	case NPV_USER_DETAILS_SUCCESS :
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map((item) => {
				npv.push({
					label : `${item.firstName} ${item.lastName}`,
					value : item.id
				});
			});
		} else {
			npv = [];
		}
		return { ...state, pending : false, error : false , npv : npv, npvUserDetails : action.payload.data ? action.payload.data : [] };
	case NPV_USER_DETAILS_ERROR :
		return { ...state, error: true, pending: false };
	case EDIT_USER_ALLOCATION :
		return { ...state, pending: true };
	case EDIT_USER_ALLOCATION_SUCCESS :
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map((item) => {
				edit_allocation.push({
					label : `${item.pipelineConfigFrom} ( ${item.rouMarkerFrom} ) - ${item.pipelineConfigTo} ( ${item.rouMarkerTo})`,
					value : `${item.id} ${item.pipelineConfigFrom} ${item.pipelineConfigTo}`
				});
			});
		} else {
			edit_allocation = [];
		}
		return { ...state, pending : false, error : false, edit_allocation : edit_allocation, edit_details : action.payload.data };
	case EDIT_USER_ALLOCATION_ERROR :
		return { ...state, error: true, pending: false };
	case ADD_ALLOCATION :
		return { ...state, pending: true };
	case ADD_ALLOCATION_SUCCESS :
		return { ...state, pending: false };
	case ADD_ALLOCATION_ERROR :
		return { ...state, error: true, pending: false };
	case EDIT_ALLOCATION :
		return { ...state, pending: true };
	case EDIT_ALLOCATION_SUCCESS :
		return { ...state, pending: false };
	case EDIT_ALLOCATION_ERROR :
		return { ...state, error: true, pending: false };
	case ALLOCATION_USER_DETAILS :
		return { ...state, pending: true };
	case ALLOCATION_USER_DETAILS_SUCCESS :
		return { ...state, pending : false, error : false, userAllocationDetails : action.payload.data ? action.payload.data : [] };
	case ALLOCATION_USER_DETAILS_ERROR :
		return { ...state, error: true, pending: false };
	case ALLOCATION_SUB :
		return { ...state, pending: true };
	case ALLOCATION_SUB_SUCCESS :
		if (action.payload) {
			pagination.total = action.payload.total ? action.payload.total : 0;
			pagination.limit = action.payload.limit ? action.payload.limit : 10;
			pagination.skip = action.payload.skip ? action.payload.skip : 0;
			pagination.current = action.page ? action.page : 1;
		}
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map((item) => {
				allocateSubUser.push({
					id : item.id,
					name : `${item.firstName} ${item.lastName}`,
					email : item.email,
					cellPhone : item.cellPhone,
					usertype : item.usertype.userType,
					usertypeId : item.usertypeId,
					allocationsList : item.allocationsList ? Array.isArray(item.allocationsList) === true ?
						item.allocationsList.map((data) => { return( <>{data.regioninfo.regionName} ( {data.pipelineConfigFrom} to {data.pipelineConfigTo} )<br/></> ); }) 
						: `${item.allocationsList.regioninfo.regionName} ( ${item.allocationsList.pipelineConfigFrom} to ${item.allocationsList.pipelineConfigTo} )` 
						: 'No allocation'
				});
			});
		}
		return { ...state, pending: false, allocateSubUser : allocateSubUser };
	case ALLOCATION_SUB_ERROR :
		return { ...state, error: true, pending: false };
	case ALLOCATION_PIPELINE_PATH :
		return { ...state, pending: true };
	case ALLOCATION_PIPELINE_PATH_SUCCESS :
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map((item) => {
				linewalkerAllocation.push({
					label : `${item.pipelineConfigFrom} ( ${item.rouMarkerFrom} ) - ${item.pipelineConfigTo} ( ${item.rouMarkerTo})`,
					value : item.id,
					startChainageId : item.zoneFromDetails && item.zoneFromDetails.id,
					endChainageId : item.zoneToDetails && item.zoneToDetails.id,
					startChainage : item.pipelineConfigFrom,
					endChainage : item.pipelineConfigTo,
					regioninfoId : item.regioninfoId
				});
			});
		} else {
			linewalker = [];
		}
		return { ...state, pending: false , linewalkerDetails : action.payload.data, linewalkerAllocation : linewalkerAllocation};
	case ALLOCATION_PIPELINE_PATH_ERROR : 
		return { ...state, error: true, pending: false };

	case EDIT_ALLOCATION_PIPELINE_PATH :
		return { ...state, pending: true };
	case EDIT_ALLOCATION_PIPELINE_PATH_SUCCESS :
		return { ...state, pending: false };
	case EDIT_ALLOCATION_PIPELINE_PATH_ERROR :
		return { ...state, error: true, pending: false };
	case INSPECTION_LIST:
		return { ...state, pending: true };
	case INSPECTION_LIST_SUCCESS:
		return { ...state, inspection_data: action.payload, pending: false };
	case INSPECTION_LIST_ERROR:
		return { ...state, error: true };
	
	case USERS_LIST:
		return { ...state, pending: true };
	case USERS_LIST_SUCCESS :
		return { ...state, users_data: action.payload, pending: false };
	case USERS_LIST_ERROR:
		return { ...state, error: true };
	case LOG_LIST :
		return { ...state, pending: true };
	case LOG_LIST_SUCCESS :
		
		if (action.payload) {
			pagination.total = action.payload.total ? action.payload.total : 0;
			pagination.limit = action.payload.limit ? action.payload.limit : 10;
			pagination.skip = action.payload.skip ? action.payload.skip : 0;
			pagination.current = action.page ? action.page : 1;
			pagination.pageSize =  action.pageSize ? action.pageSize : 10;
		}
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.forEach((item) => {

				const timecalc =  (LoginDateTime , LogoutDateTime) => {

					const login = new Date(LoginDateTime);
					const logout = new Date(LogoutDateTime);

					const diffMs = Math.abs(logout - login);
					const diffMins = Math.floor(diffMs / 60000);
					const hrs = Math.floor(diffMins / 60);
					const mins = diffMins % 60;
					return `${hrs} hrs ${mins} mins`;
					
				};
				
				const logindte = datetimeCovertertolocal(item ? item.LoginDateTime : '<Not Set>');
				const newlogindte = item && item.LoginDateTime ? (logindte.localdate + ' ' + logindte.localtime) : '<Not Set>';
				const enddte = datetimeCovertertolocal(item ? item.LogoutDateTime : '<Not Set>');
				const newenddte = item && item.LogoutDateTime ? (enddte.localdate + ' ' + enddte.localtime) : '<Not Set>';
				const duration = item && item.LogoutDateTime ? timecalc(item.LoginDateTime,item.LogoutDateTime) : '<Not Set>';		


				logs.push({
					id : item.users.id,
					name : `${item.users.firstName} ${item.users.lastName}`,
					usertype : item.users.usertype.userType,
					logindate : newlogindte,
					logoutdate : newenddte,
					usertypeId : item.usertypeId,
					duration:duration,
					status : item.status
					// allocationsList : item.allocationsList ? Array.isArray(item.allocationsList) === true ?
					// 	item.allocationsList.map((data) => { return( <>{data.regioninfo.regionName} ( {data.pipelineConfigFrom} to {data.pipelineConfigTo} )<br/></> ); }) 
					// 	: `${item.allocationsList.regioninfo.regionName} ( ${item.allocationsList.pipelineConfigFrom} to ${item.allocationsList.pipelineConfigTo} )` 
					// 	: 'No allocation'
				});
			});
			
		}
		return { ...state, pending : false, error : false, logs : logs, pagination: pagination };
	case LOG_LIST_ERROR :
		return { ...state, error: false, pending: false };
	
	
	case TASK_LIST:
		return { ...state, pending: true };
			
	case TASK_LIST_SUCCESS:
			
		if (action.payload && action.payload.data && action.payload.data.length > 0) {

			if (action.payload) {
				pagination.total = action.payload.total ? action.payload.total : 0;
				pagination.limit = action.payload.limit ? action.payload.limit : 10;
				pagination.skip = action.payload.skip ? action.payload.skip : 0;
				pagination.current = action.page ? action.page : 1;
				pagination.pageSize =  action.pageSize ? action.pageSize : 10;
				
			}

			action.payload.data.forEach((item) => {
				const startdate = datetimeCovertertolocal(item.assignedDate?item.assignedDate : '<Not Set>');
				const newstartdate = item.assignedDate ? (startdate.localdate + ' ' + startdate.localtime) : '<Not Set>';
	
				const enddate = datetimeCovertertolocal(item.endDate?item.endDate: '<Not Set>');
				const newenddate = item.endDate ? (enddate.localdate + ' ' + enddate.localtime) : '<Not Set>';
				
				tasks.push({
					id : item.id,
					name:item.name?item.name:'',
					assignedDate:newstartdate,
					endDate:newenddate,
					remarks:item.remarks?item.remarks:'',
					description:item.description?item.description:'',
					status:item.status?item.status:'',
					attachmentUrls:item.attachmentUrls,
					startassigndateUTC:item.assignedDate,
					endtaskdateUTC:item.endDate,
					allocationId : item.allocationId,
	
				});
			});
	
			return { ...state, tasks: tasks, pending: false, error: false , pagination: pagination  };
		} else {			
			
			if (action.payload && action.payload.data.length == 0) {
					
				return { ...state, tasks: [], pending: false, error: false };
			} else {

				return { ...state, tasks: [] , pending: false, error: true };
			}
		}
			
	case TASK_LIST_ERROR:
		return { ...state, pending: false, error: true };
	
	case TASK_LIST_DETAILS:
		return { ...state, pending: true };
	
	case TASK_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, details:action.payload, error: false };
	case TASK_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };
	
	case ADD_TASK_LIST_DETAILS:
		return { ...state, pending: false };
	
	case ADD_TASK_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, error: false };
	
	case ADD_TASK_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };
	
	case UPDATE_TASK_LIST:
		return { ...state, pending: false };
	
	case UPDATE_TASK_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, error: true };
		
	case UPDATE_TASK_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };
			
	case DELETE_TASK_LIST:
		return { ...state, pending: false };
	
	case DELETE_TASK_LIST_SUCCESS:
		return { ...state, pending: false, error: false };
	
	case DELETE_TASK_LIST_ERROR:
		return { ...state, pending: false, error: true };
	case GEOFENCE_MANAGEMENT_LIST:
		return { ...state, pending: true };
	case GEOFENCE_MANAGEMENT_LIST_SUCCESS:
	
			
		if (action.payload && action.payload.data.length > 0) {
			action.payload.data.map( (item) => {
				let data = {};
				data.value = item.id ? item.id : 0;
				data.label = item.name ?  item.name : '';

				return geofencemanagement.push(data);

	
			});
	
	
			// eslint-disable-next-line no-mixed-spaces-and-tabs
	
			return { ...state, geofencemanagement : geofencemanagement, pending: false, error: false };
		} else {
			if (action.payload && action.payload.length === 0) {
				return { ...state, geofencemanagement : geofencemanagement, pending: false, error: false };
			} else {
				return { ...state, pending: false, error: true };
			}
		}
	case GEOFENCE_MANAGEMENT_LIST_ERROR:
		return { ...state, pending: false, error: true };
	
	case SCHEDULE_LIST:
		return { ...state, pending: true };

	case SCHEDULE_LIST_SUCCESS:
		
		if (action.payload) {
			pagination.total = action.payload.total ? action.payload.total : 0;
			pagination.limit = action.payload.limit ? action.payload.limit : 10;
			pagination.skip = action.payload.skip ? action.payload.skip : 0;
			pagination.current = action.page ? action.page : 1;
			pagination.pageSize =  action.pageSize ? action.pageSize : 10;
		}
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.forEach((item) => {
				
				const fromTime = datetimeCovertertolocal(item ? item.datetimeFrom : '<Not Set>');
				const newFromTime = item && item.datetimeFrom ? (fromTime.localdate + ' ' + fromTime.localtime) : '<Not Set>';
				const toTime = datetimeCovertertolocal(item ? item.datetimeTo : '<Not Set>');
				const newToTime = item && item.datetimeTo ? (toTime.localdate + ' ' + toTime.localtime) : '<Not Set>';

				schedule.push({
					id : item.id,
					name : item.name,
					datetimeFrom : newFromTime,
					datetimeTo : newToTime,
					latestSchedule : item.latestSchedule,
					utcTimeTo : item.datetimeTo,
					utcTimeFrom : item.datetimeFrom
				});
			});
			
		}
		return { ...state, pending : false, error : false, schedule : schedule, pagination: pagination };

	case SCHEDULE_LIST_ERROR:
		return { ...state, error: false, pending: false };

	case DELETE_SCHEDULE:
		return { ...state, pending: false };
		
	case DELETE_SCHEDULE_SUCCESS:
		return { ...state, pending: false, error: false };
		
	case DELETE_SCHEDULE_ERROR:
		return { ...state, pending: false, error: true };

	case SCHEDULE_DETAILS:
		return { ...state, pending: true };
			
	case SCHEDULE_DETAILS_SUCCESS:
	
		return { ...state, pending: false, details:action.payload, error: false };
	case SCHEDULE_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case SCHEDULE_UPDATE:
		return { ...state, pending: false };
	case SCHEDULE_UPDATE_SUCCESS:
		return { ...state, pending: false, error: false };
	case SCHEDULE_UPDATE_ERROR:
		return { ...state, pending: false, error: true }; 

	case  ADD_SCHEDULE:
		return { ...state, pending: false };
	
	case ADD_SCHEDULE_SUCCESS:
		return { ...state, pending: false, error: false };
	
	case ADD_SCHEDULE_ERROR:
		return { ...state, pending: false, error: true };

	case QRT_USER_DETAILS :
		return { ...state, pending: true };
	case QRT_USER_DETAILS_SUCCESS :
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map((item) => {
				qrt.push({
					label : `${item.firstName} ${item.lastName}`,
					value : item.id
				});
			});
		} else {
			qrt = [];
		}
		return { ...state, pending : false, error : false , qrt : qrt, qrtUserDetails : action.payload.data ? action.payload.data : [] };
	case QRT_USER_DETAILS_ERROR :
		return { ...state, error: true, pending: false };



	case OPTIONAL_PATH_LIST:
		return { ...state, pending: true };
			
	case OPTIONAL_PATH_LIST_SUCCESS:
			
		if (action.payload && action.payload.data && action.payload.data.length > 0) {

			if (action.payload) {
				pagination.total = action.payload.total ? action.payload.total : 0;
				pagination.limit = action.payload.limit ? action.payload.limit : 10;
				pagination.skip = action.payload.skip ? action.payload.skip : 0;
				pagination.current = action.page ? action.page : 1;
				pagination.pageSize =  action.pageSize ? action.pageSize : 10;
				
			}

			action.payload.data.forEach((item) => {
				const matchedAllocation = item?.users?.userallocations?.find(
					inner => inner.id === item.allocationId
				);

				const date = datetimeCovertertolocal(item.date);
				const displaydate = date.localdate;
				
				
				path.push({
					id : item.id,
					action : item && item?.action ? item.action : '',
					chainageFrom : item && item?.chainageFrom,
					chainageTo : item && item?.chainageTo,
					status : item && item?.status,
					regionName : item && item?.regioninfo ? item?.regioninfo.regionName : '',
					userName : item && item?.users ? item.users.firstName + ' ' + item.users.lastName : '',
					allocations: matchedAllocation
						? `${item.regioninfo.regionName} ( ${matchedAllocation.pipelineConfigFrom} to ${matchedAllocation.pipelineConfigTo} )`
						: 'No allocation',
					allocationId : item && item?.allocationId,
					date : displaydate,
					currentPath : item.currentPath


				});
			});
	
			return { ...state, path: path, pending: false, error: false , pagination: pagination  };
		} else {			
			
			if (action.payload && action.payload.data.length == 0) {
					
				return { ...state, path: [], pending: false, error: false };
			} else {

				return { ...state, path: [] , pending: false, error: true };
			}
		}
			
	case OPTIONAL_PATH_LIST_ERROR:
		return { ...state, pending: false, error: true };

	case DELETE_OPTIONAL_PATH:
		return { ...state, pending: false };
		
	case DELETE_OPTIONAL_PATH_SUCCESS:
		return { ...state, pending: false, error: false };
		
	case DELETE_OPTIONAL_PATH_ERROR:
		return { ...state, pending: false, error: true };


	case OPTIONAL_PATH_LIST_DETAILS:
		return { ...state, pending: true };
	
	case OPTIONAL_PATH_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, details:action.payload, error: false };
	case OPTIONAL_PATH_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };
		
	default : {
		throw Error('Unknown action: ' + action.type);
	}

	}
}
					



				